
import Model from './Model'

export default class Payment extends Model {
  constructor (attributes = {}) {
    super(attributes.id)
    // this.cancelReason = attributes.cancelReason ?? null // VARCHAR 255
    this.change = parseFloat(attributes.change ?? 0) // DECIMAL 8,2
    this.date = attributes.date ?? this._nowToUtcString() // DATETIME
    // this.gratuity = parseFloat(attributes.gratuity ?? 0) // DECIMAL 8,2
    this.invoice_id = attributes.invoice_id ?? null // INT
    this.payAmount = parseFloat(attributes.payAmount) // DECIMAL 8,2
    this.paymentMethod = attributes.paymentMethod // INT
    this.tenantUser_id = attributes.tenantUser_id // INT
    this.tenantUserName = attributes.tenantUserName // VARCHAR 255
    this.tipAmount = parseFloat(attributes.tipAmount ?? 0) // DECIMAL 8,2
    this.turn_id = attributes.turn_id ?? null // INT|NULL
    this.voidReason = attributes.voidReason ?? null // VARCHAR 255
  }
}
